var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ./~/jszip/~/core-js/library/modules/_cof.js
// module id = OmGh
// module chunks = 0